import React from 'react';
import styled from 'styled-components';
import ICON_WIFI from '@/assets/departureWifi/icon_wifi.png';
import ICON_SWITCH from '@/assets/departureWifi/icon_switch.png';
import { WIFI } from '@/constant/departure.const';
import { ICON_INFO } from '@repo/assets';

type Props = {
  place?: 'airport' | 'port';
};

function IosIpBlocking({ place = 'airport' }: Props) {
  return (
    <WifiList>
      <WifiItem>
        <WifiDescription>
          1. 와이파이 연결 후 <img src={ICON_INFO} alt='' width={14} /> 아이콘
          클릭
        </WifiDescription>
        <WifiName>
          {WIFI[place]}
          <WifiNameRight>
            <img src={ICON_WIFI} alt='' width={16} />
            <Circle>
              <img src={ICON_INFO} alt='' width={16} />
            </Circle>
          </WifiNameRight>
        </WifiName>
      </WifiItem>
      <WifiItem>
        <WifiDescription>2. 하단의 2가지 설정 끄기</WifiDescription>
        <WifiName>
          비공개 Wi-Fi 주소
          <img src={ICON_SWITCH} alt='' width={30} />
        </WifiName>
        <WifiName>
          IP 주소 추적 제한
          <img src={ICON_SWITCH} alt='' width={30} />
        </WifiName>
      </WifiItem>
    </WifiList>
  );
}

const WifiList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
  border-radius: 12px;
  background-color: #f5f6f7;
`;

const WifiItem = styled.li`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const WifiDescription = styled.dt`
  font-size: 12px;
  font-weight: 600;
  color: #3a3b3e;
  display: flex;
  align-items: center;

  & > img {
    margin: 0 4px;
  }
`;

const WifiName = styled.dd`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background-color: #ffffff;
  border-radius: 6px;
  font-size: 12px;
  color: #030303;
`;

const WifiNameRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
`;

const Circle = styled.div`
  position: relative;
  &:after {
    content: '';
    width: 32px;
    height: 32px;
    border: 2px solid #ff2d55;
    border-radius: 40px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export default IosIpBlocking;
